/* global axios */
import ApiClient from './ApiClient';

class CompanyFieldDefinitionsAPI extends ApiClient {
  constructor() {
    super('company_field_definitions', { accountScoped: true });
  }

  getAll() {
    return axios.get(this.url);
  }

  create(payload) {
    return axios.post(this.url, payload);
  }

  update(id, payload) {
    return axios.patch(`${this.url}/${id}`, payload);
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  reorder(ids) {
    return axios.post(`${this.url}/reorder`, { ids });
  }
}

export default new CompanyFieldDefinitionsAPI();
